import { ExternalLink, Heading } from '@app/shared/ui/atoms/Common';
import { S3_HOST } from '@app/assets';

export function HeadingSection() {
  return (
    <section className="flex items-center justify-between px-4">
      <Heading level={3} className="h-8 rounded-sm bg-blue-100 px-2 text-accent">
        PreSale
      </Heading>
      <ExternalLink
        url={`${S3_HOST}/presentations/DOM_INFO.pdf`}
        className="ml-6 flex size-8 items-center justify-center rounded-sm bg-accent text-xl font-black text-foreground"
      >
        ?
      </ExternalLink>
    </section>
  );
}
